import { makeStyles } from "@mui/styles";
import React from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Box, Button, CircularProgress, Divider, FormControl, Grid, Paper, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import CreateVoluntaryOTSignupIAM from "../../components/overtime/CreateVoluntaryOTSignupIAM";
import CreateVoluntaryOTSignupTWU from "../../components/overtime/CreateVoluntaryOTSignupTWU";
import { getUnionContractGivenWorkgroup } from "../../util/workgroupMapper";
import { IAM_CONTRACT, TWU_CONTRACT } from "../../util/constants";
import { useSelector } from "react-redux";
import { selectUserSession } from "../../slices/userSession/userSessionSlice";

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    fontSize: "24px",
    textAlign: "left",
    margin: "auto",
    marginTop: "10px",
    marginLeft: "20px",
    whiteSpace: "normal",
  },
  otListItem: {
    margin: "10px",
    padding: "10px",
    textAlign: "left",
    background: theme.palette.secondary.swaGray1,
  },
  otListOwnItem: {
    margin: "10px",
    padding: "10px",
    textAlign: "left",
    background: theme.palette.secondary.swaLightestBlue,
  },
  redStatusColor: {
    color: theme.palette.primary.swaRed,
  },
  requestFont: {
    fontSize: "12px",
  },
}));

const VoluntaryOTListMobile = (props) => {
  //#region Constants
  const classes = useStyles();
  const userSession = useSelector(selectUserSession);
  //#endregion

  //#region Component Renders
  const renderVoluntaryOTListMobilePage = () => {
    return (
      <div className="voluntary-ot-list-mobile-page">
        <Grid container justifyContent="center" spacing={1}>
          <Grid container className="mobile-title-row">
            <Typography component={"div"}>
              <Box className={classes.pageTitle}>{props.renderScreenTitle()}</Box>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Box mt={1} mb={1}>
              <FormControl variant="outlined">{props.dateInput}</FormControl>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box mt={1} mb={1}>
              {props.searchInput}
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          <Box
            sx={{
              bgcolor: "secondary.swaLightestBlue",
              width: "100%",
              height: "60px",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              borderTop: "solid 1px",
              borderLeft: "solid 1px",
              borderRight: "solid 1px",
              borderColor: "secondary.swaGray2",
              borderRadius: 0,
            }}
          >
            <Stack
              sx={{ height: "100%", justifyContent: "left", alignItems: "center", padding: "15px" }}
              direction="row"
              divider={<Divider sx={{ marginTop: "5px", marginBottom: "5px" }} orientation="vertical" flexItem />}
            >
              <Grid container justifyContent="space-between" alignItems="right">
                <Grid item xs={7} sm={7}></Grid>
                <Grid item xs={5} sm={5}>
                  <Button
                    style={{ backgroundColor: "white", paddingLeft: 8, paddingRight: 8 }}
                    size="small"
                    fullWidth
                    onClick={props.handleClickMobileFilterDialogOpen.bind(this)}
                    sx={{ border: "solid 0.5px", borderColor: "secondary.swaBlue" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="space-between"
                      alignItems="center"
                      alignContent="center"
                    >
                      <Grid item alignItems="center" xs={3} sm={2} md={1}>
                        <FilterAltIcon sx={{ marginTop: 1, fontSize: "18px" }} />
                      </Grid>
                      <Grid item xs={9} sm={10} md={11}>
                        <Typography sx={{ fontSize: "14px" }}>Filters</Typography>
                      </Grid>
                    </Grid>
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} sx={{ width: "100%", padding: "10px" }}>
          {getUnionContractGivenWorkgroup(props.workgroup) === IAM_CONTRACT && (
            <CreateVoluntaryOTSignupIAM
              isDesktopView={props.isDesktopView}
              station={props.station}
              workgroup={props.workgroup}
              selectedDate={props.selectedDate}
            />
          )}
          {getUnionContractGivenWorkgroup(props.workgroup) === TWU_CONTRACT && (
            <CreateVoluntaryOTSignupTWU
              isDesktopView={props.isDesktopView}
              station={props.station}
              workgroup={props.workgroup}
              selectedDate={props.selectedDate}
            />
          )}
        </Grid>
        <div className="enable-scroll">
          {props.isLoading ? (
            <CircularProgress />
          ) : (
            <div>
              {props.otRequests.map((otRequest) => {
                return (
                  <Paper
                    key={otRequest.eventId}
                    className={otRequest.eid === userSession.eid ? classes.otListOwnItem : classes.otListItem}
                    elevation={1}
                    data-testid={otRequest.eventId}
                    onClick={() => props.setOtRequestSelectedForMoreInfo(otRequest)}
                  >
                    {
                      <div>
                        <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {otRequest.lastName}, {otRequest.firstName} |
                          {otRequest.isBeforeDeadline ? (
                            <b> Above</b>
                          ) : (
                            <b className={classes.redStatusColor}> Below</b>
                          )}
                        </div>
                        <div className={classes.requestFont}>{`Scheduled Hours: ${
                          otRequest.isOff
                            ? "OFF"
                            : otRequest.shifts.map((shift) => shift.start + "-" + shift.end).join(", ")
                        }`}</div>
                        <div className={classes.requestFont}>OT Assignment:</div>
                      </div>
                    }
                  </Paper>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  };

  return <div data-testid="voluntary-ot-list-mobile">{renderVoluntaryOTListMobilePage()}</div>;
  //#endregion
};

VoluntaryOTListMobile.propTypes = {
  dateInput: PropTypes.element.isRequired,
  searchInput: PropTypes.element.isRequired,
  station: PropTypes.string.isRequired,
  workgroup: PropTypes.string.isRequired,
  selectedDate: PropTypes.object.isRequired,
  handleClickMobileFilterDialogOpen: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  renderScreenTitle: PropTypes.func.isRequired,
  otRequests: PropTypes.array.isRequired,
  setOtRequestSelectedForMoreInfo: PropTypes.func.isRequired,
};

export default VoluntaryOTListMobile;
